export const FETCH_POINTS = 'SETTINGS:PASSWORD:FETCH_POINTS';
export const FETCH_POINTS_SUCCESS = 'SETTINGS:PASSWORD:FETCH_POINTS_SUCCESS';
export const FETCH_POINTS_ERROR = 'SETTINGS:PASSWORD:FETCH_POINTS_ERROR';

export const FETCH_OFFER = 'SETTINGS:PASSWORD:FETCH_OFFER';
export const FETCH_OFFER_SUCCESS = 'SETTINGS:PASSWORD:FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_ERROR = 'SETTINGS:PASSWORD:FETCH_OFFER_ERROR';

export const SET_PASSWORD_RECOVERY_CHANNEL = 'SETTINGS:PASSWORD:SET_PASSWORD_RECOVERY_CHANNEL';
export const SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS = 'SETTINGS:PASSWORD:SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS';
export const SET_PASSWORD_RECOVERY_CHANNEL_ERROR = 'SETTINGS:PASSWORD:SET_PASSWORD_RECOVERY_CHANNEL_ERROR';

export const SAVE_NOTIFICATION_POINT = 'SETTINGS:PASSWORD:SAVE_NOTIFICATION_POINT';
export const SAVE_NOTIFICATION_POINT_SUCCESS = 'SETTINGS:PASSWORD:SAVE_NOTIFICATION_POINT_SUCCESS';
export const SAVE_NOTIFICATION_POINT_ERROR = 'SETTINGS:PASSWORD:SAVE_NOTIFICATION_POINT_ERROR';

export const CONFIRM_NOTIFICATION_POINT_CODE = 'SETTINGS:PASSWORD:CONFIRM_NOTIFICATION_POINT_CODE';
export const CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:PASSWORD:CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS';
export const CONFIRM_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:PASSWORD:CONFIRM_NOTIFICATION_POINT_CODE_ERROR';

export const SEND_NOTIFICATION_POINT_CODE = 'SETTINGS:PASSWORD:SEND_NOTIFICATION_POINT_CODE';
export const SEND_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:PASSWORD:SEND_NOTIFICATION_POINT_CODE_SUCCESS';
export const SEND_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:PASSWORD:SEND_NOTIFICATION_POINT_CODE_ERROR';

export const CHANGE_PASSWORD = 'SETTINGS:PASSWORD:CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'SETTINGS:PASSWORD:CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'SETTINGS:PASSWORD:CHANGE_PASSWORD_ERROR';

export const SAVE_ACCESS_CONFIG = 'SETTINGS:PASSWORD:SAVE_ACCESS_CONFIG';
export const SAVE_ACCESS_CONFIG_SUCCESS = 'SETTINGS:PASSWORD:SAVE_ACCESS_CONFIG_SUCCESS';
export const SAVE_ACCESS_CONFIG_ERROR = 'SETTINGS:PASSWORD:SAVE_ACCESS_CONFIG_ERROR';

export const FETCH_INTERNET_LOGIN = 'SETTINGS:PASSWORD:FETCH_INTERNET_LOGIN';
export const FETCH_INTERNET_LOGIN_SUCCESS = 'SETTINGS:PASSWORD:FETCH_INTERNET_LOGIN_SUCCESS';
export const FETCH_INTERNET_LOGIN_ERROR = 'SETTINGS:PASSWORD:FETCH_INTERNET_LOGIN_ERROR';

export const CHANGE_INTERNET_LOGIN = 'SETTINGS:PASSWORD:CHANGE_INTERNET_LOGIN';
export const CHANGE_INTERNET_LOGIN_SUCCESS = 'SETTINGS:PASSWORD:CHANGE_INTERNET_LOGIN_SUCCESS';
export const CHANGE_INTERNET_LOGIN_ERROR = 'SETTINGS:PASSWORD:CHANGE_INTERNET_LOGIN_ERROR';

export const CHANGE_INTERNET_PASSWORD = 'SETTINGS:PASSWORD:CHANGE_INTERNET_PASSWORD';
export const CHANGE_INTERNET_PASSWORD_SUCCESS = 'SETTINGS:PASSWORD:CHANGE_INTERNET_PASSWORD_SUCCESS';
export const CHANGE_INTERNET_PASSWORD_ERROR = 'SETTINGS:PASSWORD:CHANGE_INTERNET_PASSWORD_ERROR';

export const TOGGLE_POINT_EDITING_STATE = 'SETTINGS:PASSWORD:TOGGLE_POINT_EDITING_STATE';

export const TOGGLE_CONFIRMATION_CODE_POPUP = 'SETTINGS:PASSWORD:TOGGLE_CONFIRMATION_CODE_POPUP';

export const RESET_NOTIFICATION_POINT_CODE_VALIDATION = 'SETTINGS:PASSWORD:RESET_NOTIFICATION_POINT_CODE_VALIDATION';

export const RESET_ERROR = 'SETTINGS:PASSWORD:RESET_ERROR';

export const CONFIRMATION_POPUP_KEY = 'SETTINGS:PASSWORD:CONFIRMATION';
export const EDITING_POPUP_KEY = 'SETTINGS:PASSWORD:EDITING';

export const OFFER_TYPE = 'HE';

export const OFFER_ACCEPT_TYPES = {
  FREE: 'FREE',
  RESTRICTED: 'RESTRICTED',
  CAPTCHA: 'CAPTCHA',
  PASS: 'PASS',
};

export const LOGIN_ALREADY_EXISTS_ERROR = 20068;

export const SAME_PASSWORD_TEXT = 'Новый пароль совпадает со старым паролем';
